import { memo } from 'react';
import { getFileExtension, imageTypes, officeTypes, pdfTypes, videoTypes } from './utils';

import { Unsupported } from './Components/Unsupported';
import { PdfRenderer } from './Components/PdfRenderer';
import { ImageRenderer } from './Components/ImageRenderer';
import { OfficeRenderer } from './Components/OfficeRenderer';
import { VideoRenderer } from './Components/VideoRenderer';

const Previewer = memo(({ signedUrl, type, url, height = '80vh', width = '100%' }) => {
    const finalType = type?.toLowerCase() || (url ? getFileExtension(url) : null);

    if (!finalType) return <Unsupported type="unknown" />;

    if (pdfTypes.includes(finalType)) {
        return <PdfRenderer url={signedUrl} height={height} width={width} />;
    }

    if (imageTypes.includes(finalType)) {
        return <ImageRenderer url={signedUrl} height={height} width={width} />;
    }

    if (officeTypes.includes(finalType)) {
        return <OfficeRenderer url={signedUrl} fileType={finalType} height={height} width={width} />;
    }

    if (videoTypes.includes(finalType)) {
        return <VideoRenderer url={signedUrl} height={height} width={width} />;
    }

    return <Unsupported type={finalType} />;
});

export { Previewer };
